module.exports = __webpack_public_path__ + "img/logo.c9430265.png";